import { Box, Container } from '@chakra-ui/react'
import { gql } from 'graphql-request'
import ButtonBlock from './ButtonBlock'
import { CalloutBlock } from './CalloutBlock'
import { GalleryBlock } from './GalleryBlock'
import ImageAndTextBlock from './ImageAndTextBlock'
import TextBlock from './TextBlock'
import { VideoBlock } from './VideoBlock'

export const contentBlocksQuery = gql`
  content_blocks {
    ... on Set_ContentBlocks_Gallery {
      gallery_title
      gallery_images {
        url
        height
        width
      }
      type
    }
    ... on Set_ContentBlocks_ImageAndText {
      text
      position
      type
      image {
        url
      }
      image_styles
    }
    ... on Set_ContentBlocks_Video {
      video
      type
    }
    ... on Set_ContentBlocks_Button {
      button_text
      button_url
      type
    }
    ... on Set_ContentBlocks_Html {
      html
      type
    }
    ... on BardText {
      text
      type
    }
    ... on Set_ContentBlocks_Spacer {
      hr
      type
    }
    ... on Set_ContentBlocks_Callout {
      heading
      subheading
      buttons {
        ... on Set_ContentBlocks_Buttons_Buttons {
          button_text
          button_url
          button_target_blank
        }
      }
      paywall
      paywall_message
      visible_to {
        handle
      }
      type
    }
  }
`

export const ContentBlocks = ({ content_blocks }: any) => {
  // Get number of text blocks and center short ones
  const textBlock = content_blocks.find((block: any) => block.type === 'text')
  const textAlign = textBlock?.text?.length < 150 ? 'center' : 'left'

  return content_blocks ? (
    <>
      {content_blocks.map((block: any, i: number) => (
        <Box my={12} key={i}>
          {block.type == 'gallery' && <GalleryBlock {...block} />}
          {block.type == 'text' && (
            <TextBlock {...block} textAlign={textAlign} />
          )}
          {block.type == 'button' && <ButtonBlock {...block} />}
          {block.type == 'image_and_text' && <ImageAndTextBlock {...block} />}
          {block.type == 'video' && <VideoBlock {...block} />}
          {block.type == 'html' && (
            <Container>
              <div dangerouslySetInnerHTML={{ __html: block.html }} />
            </Container>
          )}
          {block.type == 'callout' && <CalloutBlock {...block} />}
        </Box>
      ))}
    </>
  ) : null
}
